import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { CcsButtonDirective } from '@shared/directives/button';
import { TokenService } from '@shared/services/token.service';

const SESSION_INVALID_DIALOG_ID = 'session-invalid-dialog';

@Component({
  selector: 'app-session-invalid-dialog',
  standalone: true,
  imports: [MatButton, CcsButtonDirective, MatDialogTitle, MatDialogContent, MatDialogActions],
  templateUrl: './session-invalid-dialog.component.html',
})
export class SessionInvalidDialogComponent {
  private readonly tokenService = inject(TokenService);

  static open(dialog: MatDialog): void {
    if (dialog.getDialogById(SESSION_INVALID_DIALOG_ID)) {
      return;
    }

    dialog.open(SessionInvalidDialogComponent, {
      id: SESSION_INVALID_DIALOG_ID,
      disableClose: true,
    });
  }

  acknowledgeSession(): void {
    this.tokenService.endSession();
  }
}
